module.exports = __webpack_public_path__ + "media/application/images/employer-468bfaacc9978329a825b55a43c08d66.png";